var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"filter"}},[_c('div',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"close"},on:{"click":_vm.close}},[_c('i',{staticClass:"fad fa-times fs-2x text-dark cursor-pointer"})]),_c('img',{staticClass:"w-100 h-100 object-fit-contain",attrs:{"src":_vm.$store.state.imageZoom,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }